export class ContatoreStatoNoteVO {
  totali: number;
  liberi: number;
  inCarico: number;
}

// { [tipoNota: string]: { [stato: string]: ContatoreStatoNoteVO } }
export class ContatoreNoteVO {
  [tipoNota: string]: { [stato: string]: ContatoreStatoNoteVO };
}
